import React from 'react'
import './Footer.css'
import '../../Global.css'
function Footer() {
  return (
    <div className="footer">
        <p>&copy; Oitijya Islam Auvro, 2026</p>
    </div>
  )
}

export default Footer
